import { defineComponent as y, computed as r, openBlock as V, createElementBlock as b, createElementVNode as p, normalizeClass as B, toDisplayString as x } from "vue";
import { E as n } from "./EnumParser.dab943ef.js";
import { g as w } from "./getDataEventValue.a20ca383.js";
import { F as f } from "./FrontiersIcon.fac4da01.js";
import '../assets/CustomLink.css';var o = /* @__PURE__ */ ((e) => (e.Link = "linkType", e.FlatButton = "flatButton", e.OutlineButton = "outlineButton", e))(o || {}), u = /* @__PURE__ */ ((e) => (e.Maincolor = "maincolor", e.Grey = "grey", e.White = "white", e.Sky40 = "sky40", e.Blue40 = "blue40", e.Blue50 = "blue50", e.Blue80 = "blue80", e))(u || {}), E = /* @__PURE__ */ ((e) => (e.None = "none", e.ChevronRight = "chevronRight", e.ArrowRight = "arrowRight", e.Facebook = "facebook", e.Instagram = "instagram", e.Twitter = "twitter", e.LinkedIn = "linkedin", e.Download = "download", e))(E || {}), i = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e))(i || {}), s = /* @__PURE__ */ ((e) => (e.Right = "right", e.Left = "left", e))(s || {});
const L = { class: "Link__wrapper" }, T = ["aria-label", "href", "target", "data-event"], F = /* @__PURE__ */ y({
  __name: "CustomLink",
  props: {
    link: {},
    color: { default: u.Maincolor },
    icon: { default: "None" },
    type: { default: o.Link },
    size: { default: i.Small },
    iconLocation: { default: s.Right },
    hiddenText: { type: Boolean, default: !1 },
    dataEvent: {}
  },
  setup(e) {
    const t = e, c = r(() => t.hiddenText === !0 ? "" : t.link.text), d = r(() => t.link.ariaLabel || t.link.text), h = r(() => {
      const a = ["Link"], l = n.getValue(o, t.type) || "defaultType", k = n.getValue(u, t.color) || "defaultColor", m = n.getValue(f, t.icon) || "defaultIcon", v = n.getValue(i, t.size) || "defaultSize", _ = n.getValue(s, t.iconLocation) || "defaultIconLocation";
      return a.push(`Link--${l}`), a.push(`Link--${k}`), a.push(`Link--${v}`), l !== o.Link && a.push(`Link--${l}`), m !== f.None && (a.push(`Link--icon Link--${m}`), a.push(`Link--${_}`), t.link.text === "" && a.push("Link--noText")), a;
    }), g = () => t.dataEvent || w("customLink", t.type, [
      "a",
      c.value || d.value
    ]);
    return (a, l) => (V(), b("span", L, [
      p("a", {
        class: B(h.value),
        "aria-label": d.value,
        href: a.link.url,
        target: a.link.target,
        "data-event": g()
      }, [
        p("span", null, x(c.value), 1)
      ], 10, T)
    ]));
  }
});
export {
  o as L,
  F as _,
  u as a,
  i as b,
  s as c,
  E as d
};
